import { render, staticRenderFns } from "./ProjectQuestionList.vue?vue&type=template&id=75713761&"
import script from "./ProjectQuestionList.vue?vue&type=script&lang=js&"
export * from "./ProjectQuestionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports